import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Coffee(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Coffee", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M40 32h-5c-.2652 0-.5196-.1054-.7071-.2929S34 31.2652 34 31c0-.2652.1054-.5196.2929-.7071S34.7348 30 35 30h5c.7956 0 1.5587-.3161 2.1213-.8787C42.6839 28.5587 43 27.7956 43 27v-2c0-.7956-.3161-1.5587-.8787-2.1213C41.5587 22.3161 40.7956 22 40 22h-5c-.2652 0-.5196-.1054-.7071-.2929S34 21.2652 34 21c0-.2652.1054-.5196.2929-.7071S34.7348 20 35 20h5c1.3256.0016 2.5964.5289 3.5338 1.4662.9373.9374 1.4646 2.2082 1.4662 3.5338v2c-.0016 1.3256-.5289 2.5964-1.4662 3.5338C42.5964 31.4711 41.3256 31.9984 40 32Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M27 39v1h-6v-1c-3.1826 0-6.2348-1.2643-8.4853-3.5147C10.2643 33.2348 9 30.1826 9 27v-7c0-.2652.10536-.5196.29289-.7071C9.48043 19.1054 9.73478 19 10 19h28c.2652 0 .5196.1054.7071.2929S39 19.7348 39 20v7c0 3.1826-1.2643 6.2348-3.5147 8.4853C33.2348 37.7357 30.1826 39 27 39Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M3 39h42c0 1.0609-.4214 2.0783-1.1716 2.8284C43.0783 42.5786 42.0609 43 41 43H7c-1.06087 0-2.07828-.4214-2.82843-1.1716C3.42143 41.0783 3 40.0609 3 39Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M24 17c-.2652 0-.5196-.1054-.7071-.2929S23 16.2652 23 16c0-.2652-.1054-.5196-.2929-.7071S22.2652 15 22 15h-5c-.7956 0-1.5587-.3161-2.1213-.8787C14.3161 13.5587 14 12.7956 14 12c0-.7956.3161-1.5587.8787-2.12132C15.4413 9.31607 16.2044 9 17 9h14c.2652 0 .5196-.10536.7071-.29289C31.8946 8.51957 32 8.26522 32 8s-.1054-.51957-.2929-.70711C31.5196 7.10536 31.2652 7 31 7h-7c-.2652 0-.5196-.10536-.7071-.29289C23.1054 6.51957 23 6.26522 23 6s.1054-.51957.2929-.70711C23.4804 5.10536 23.7348 5 24 5h7c.7956 0 1.5587.31607 2.1213.87868C33.6839 6.44129 34 7.20435 34 8s-.3161 1.55871-.8787 2.1213C32.5587 10.6839 31.7956 11 31 11H17c-.2652 0-.5196.1054-.7071.2929S16 11.7348 16 12c0 .2652.1054.5196.2929.7071S16.7348 13 17 13h5c.7956 0 1.5587.3161 2.1213.8787C24.6839 14.4413 25 15.2044 25 16c0 .2652-.1054.5196-.2929.7071S24.2652 17 24 17Z",
        fill: theme.vars.palette.secondary.main
      }
    )
  ] });
}
Coffee.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Coffee"
};
validateTidalLicense();
export {
  Coffee
};
//# sourceMappingURL=Coffee.js.map
